<div class="card pl-10 pt-5">
  <h1 class="font-bold">{{ data.name }}</h1>
  <div class="flex justify-end pr-10">
    @if (data.servings > 0) {
      {{ data.servings }}
      @if (data.servings2 > 0) {
        -{{ data.servings2 }}
      }
      <span i18n>servings</span> {{ data.servingsNode }}
    }
  </div>
</div>
<div class="card pl-10 pb-10">
  <ul class="list-disc list-inside space-y-1 pl-5 text-gray-600">
    @for (item of data.ingredients; track item.id) {
      <li>
        @if (item.ammount > 0) {
          {{ item.ammount }}
          @if (item.ammount2 > 0) {
            - {{ item.ammount2 }}
          }
        }
        @for (unit of types; track unit.id) {
          @if (item.unit.id == unit.id) {
            {{ unit.unit }}
          }
        }

        @for (ingredient of ingredients; track ingredient.id) {
          @if (item.ingredient.id == ingredient.id) {
            {{ ingredient.name }}
          }
        }
      </li>
    }
  </ul>
</div>
<div class="card pl-10">
  <div [innerHTML]="data.description" class="pb-4"></div>
  <div>
    @if (data.cooktimeS > 0) {
      <b><span i18n>Cooktime:</span> {{ data.cooktimeS / 60 }} <span i18n>min</span></b>
    }
  </div>
  <div>
    @if (data.oventimeS) {
      <b><span i18n>Oventime:</span> {{ data.oventimeS / 60 }} <span i18n>min</span></b>
    }
  </div>
  <div>
    @if (data.timeSpentInKichenS) {
      <b
        ><span i18n>Time in kichen:</span> {{ data.timeSpentInKichenS / 60 }}
        <span i18n>min</span></b
      >
    }
  </div>
  <div>
    @if (data.totalTimeS) {
      <b><span i18n>Totaltime:</span> {{ data.totalTimeS / 60 }} <span i18n>min</span></b>
    }
  </div>
  <div>
    {{ data.endDescription }}
  </div>
</div>
